module.exports = __webpack_public_path__ + "static/img/not-login-footer2.960d002.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/not-login-footer2.png
// module id = 0dls
// module chunks = 4